export var MORE_THEN_OR_EQUAL = '>=';
export var EQUAL = '==';
export var LESS_THEN_OR_EQUAL = '<=';
export function matchVersion(_a) {
	var ua = _a.ua,
		regExp = _a.regExp,
		groupIndex = _a.groupIndex,
		version = _a.version,
		operator = _a.operator,
		_b = _a.reductionToNumber,
		reductionToNumber = _b === void 0 ? 'auto' : _b,
		_c = _a.transformMatch,
		transformMatch =
			_c === void 0
				? function (v) {
						return v;
				  }
				: _c;
	var match = regExp.exec(ua);
	if (match) {
		var int = version === parseInt('' + version, 10);
		var _m = transformMatch(match[groupIndex]);
		var value = void 0;
		switch (reductionToNumber) {
			case 'int':
				value = parseInt(_m);
				break;
			case 'float':
				value = parseFloat(_m);
				break;
			default:
				value = int ? parseInt(_m) : parseFloat(_m);
		}
		if (isNaN(value)) {
			return false;
		} else {
			switch (operator) {
				case MORE_THEN_OR_EQUAL:
					return value >= version;
				case EQUAL:
					return value === version;
				case LESS_THEN_OR_EQUAL:
					return value <= version;
			}
		}
	} else {
		return false;
	}
}
export function transformMacOSorIPadOSVersionMatch(version) {
	return version
		.replace(/_/g, '.')
		.replace(/^(\d\d)\.(\d)(\.|$)/, function (str, g1, g2, g3) {
			return g1 + '.0' + g2 + g3;
		})
		.replace('.', '');
}
